import BaseModule from './BaseModule'
import logger from './logger'
import type { Callback } from './types'

class UC extends BaseModule {
  private user = {
    appId: '1',
    openId: '2',
    nickname: '3',
    avatar: ''
  }

  /**
   * 废弃
   * 判断用户是否登录
   * @param callback 判断是否登录回调
   */
  public isLogin(callback: Callback): void {
    logger.info('check is login')
    callback({
      code: 1000,
      message: 'success',
      payload: true
    })
  }

  /**
   * 废弃
   * 用户登录
   * @param callback 登录回调
   */
  public login(callback: Callback<UserInfo>): void {
    logger.info('login')
    callback({
      code: 1000,
      message: 'success',
      payload: this.user
    })
  }

  /**
   * 选接
   * 获取用户信息
   * @param callback 获取用户信息回调
   */
  public getUserInfo(callback: Callback<UserInfo>): void {
    logger.info('get user info')

    callback({
      code: 1000,
      message: 'success',
      payload: this.user
    })
  }
}

type UserInfo = {
  // app ID
  appId: string
  // 用户ID
  openId: string
  // 用户昵称
  nickname: string
  // 用户头像
  avatar: string
}

export default UC
